export const TELLER_PROFILE_DETAIL = 'teller_list'
export const TELLER_PROFILE_DEFAULT = 'teller_default'
export const ADD_FAVORITE = 'add-favotire'
export const REMOVE_FAVORITE = 'remove-favorite'
export const GET_REVIEWS_TELLER = 'get-reviews-teller'
export const TELLER_PROFILE_POSTS = 'teller_posts'
export const TELLER_POSTS_DEFAULT = 'teller_posts_default'
